import Yup from '../yup';

const person = () =>
  Yup.object()
    .shape({
      prp_giv_nam: Yup.string()
        .trim()
        .csvGivenName(true) // This allows spaces, but only in EVR applications
        .required("Please enter the protected person's first name"),
      prp_fam_nam: Yup.string()
        .trim()
        .required("Please enter the protected person's last name"),
      prp_dob2: Yup.string()
        .trim()
        .csvDatePast()
        .csvDate('Invalid date', true)
        .required("Please enter the protected person's date of birth"),
      prp_sex: Yup.string()
        .trim()
        .required("Please enter the protected person's gender"),
      prp_sex_other: Yup.string().when('prp_sex', {
        is: 'U',
        then: Yup.string().required(
          "Please enter the protected person's gender"
        ),
      }),
      seeking_appl_role: Yup.string()
        .trim()
        .required('Please indicate how you represent the protected person'),
      seeking_appl_sub_role: Yup.string()
        .trim()
        .required(
          'Please indicate whether the protected person (or their parent/guardian) consents to the application'
        ),
    })
    .required('Please enter the required details for the protected person');

export default person;
